import { LegalPage } from "./legal/LegalPage";
import YourDataDocument from "./dynamic/YourData";

export default function YourDataComponent() {
  return (
    <LegalPage path="/your-data">
      <YourDataDocument />
    </LegalPage>
  );
}
